import React from 'react';
import uploadImage from 'lib/plugins/slate-upload-image';

import Button from './../styled/Button';
import Icon from './../styled/Icon';

import Input from './Input';

// const upload = {
//   api: 'https://staging.politicoapps.com/api/services/s3imageservice/',
//   authorization: 'Token 029b4c7b6fff4163b4a1f80b4a22e0',
// };

class Dialogue extends React.Component {
  constructor(props) {
    super(props);
    this.Input = React.createRef();

    this.handleImage = this.handleImage.bind(this);

    const {imageAPI, authorization} = this.props;

    this.upload = uploadImage({
      api: imageAPI,
      authorization,
    });
  }

  handleImage(e) {
    const img = e.target.files[0];
    const { onChange, editor } = this.props;
    editor.change(change => Promise
      .resolve(this.upload(change, img, editor))
      .then(() => { onChange(change); })
    );
  }

  render() {
    return (
      <div>
        <Button
          onMouseDown={() => {
            this.Input.current.openFileFinder();
          }}
        >
          <Icon className='far fa-images' />
        </Button>

        <Input
          onChange={this.handleImage}
          ref={this.Input}
        />
      </div>
    );
  }
}

export default Dialogue;
